export const RECIPES_NAMES = {
    ACBP_RECIPE: "ACBPRecipe"
}